import React from "react";
import { ITabComposition } from "../../interfaces/ITab";
import {
  Body,
  Desc,
  Frame,
  Header,
  Item,
  Name,
  Period,
  Place,
  TimeItem,
  TimeLine,
} from "./styles/Tab";

const Tab: React.FC & ITabComposition = ({ children, ...restProps }) => (
  <Frame {...restProps}>{children}</Frame>
);

Tab.Header = function TabHeader({ children, ...restProps }) {
  return <Header {...restProps}>{children}</Header>;
};

Tab.Body = function TabBody({ children, ...restProps }) {
  return <Body {...restProps}>{children}</Body>;
};

Tab.Item = function TabItem({ children, ...restProps }) {
  return <Item {...restProps}>{children}</Item>;
};

Tab.TimeLine = function TabTimeLine({ children, ...restProps }) {
  return <TimeLine {...restProps}>{children}</TimeLine>;
};

Tab.TimeItem = function TabTimeItem({ children, ...restProps }) {
  return <TimeItem {...restProps}>{children}</TimeItem>;
};

Tab.Period = function TabDate({ children, ...restProps }) {
  return <Period {...restProps}>{children}</Period>;
};

Tab.Name = function TabName({ children, ...restProps }) {
  return <Name {...restProps}>{children}</Name>;
};

Tab.Place = function TabPlace({ children, ...restProps }) {
  return <Place {...restProps}>{children}</Place>;
};

Tab.Desc = function TabDesc({ children, ...restProps }) {
  return <Desc {...restProps}>{children}</Desc>;
};

export default Tab;
